import { Reveal } from "@/components/Reveal";

/**
 * SectionHeading — label kicker + judul H2 + deskualifikasi opsional.
 * Reusable di seluruh section agar konsisten.
 */
export const SectionHeading = ({
  kicker,
  title,
  description,
  align = "left",
  chapter,
  className = "",
}) => {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${className}`}>
      {kicker && (
        <Reveal>
          <div className="flex items-center gap-3 mb-4">
            {chapter && (
              <span className="text-sm font-bold text-[#E0A400] tabular-nums">
                {chapter}
              </span>
            )}
            <span className="text-sm font-bold uppercase tracking-[0.2em] text-slate-500">
              {kicker}
            </span>
            <span className="h-px w-10 bg-[#E0A400]/50" aria-hidden="true" />
          </div>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold tracking-tight text-slate-900 leading-[1.1]">
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.1}>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionHeading;
